import React from "react";
import { Admin1 } from "assets/icons";
import styled from "styled-components";
function SubAdminComponent({
  name = "Sub Admin. 1",
  role = "2 Sub-Administrator 1",
  clickEvent,
}) {
  return (
    <Container onClick={clickEvent}>
      <img src={Admin1} alt="" />
      <p>{name}</p>
      <span>{role}</span>
    </Container>
  );
}

export default SubAdminComponent;

const Container = styled.div`
  background-color: #fff;
  gap: 10px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 10px;
  width: 100%;
  margin-right: 10px;
  cursor: pointer;

  span {
    font-size: 13px;
  }
  img {
    width: 100px;
  }
`;
